import React, { useEffect } from "react";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { UPDATE_ORG_PROFILE } from '../../../queries';
import { TitleSource } from '../teleporters/Title';
import { useState } from "react";
import '../../../styles/Admin.scss';
import { Button, Col, Form, Row } from "react-bootstrap";
import { withToastManager } from "react-toast-notifications";
import { assign } from "lodash";
import { BlockPicker, ChromePicker } from 'react-color';


const OrgProfile = (props:any) => {
   /* let { orgId } = useParams();*/

    // Instantiate _orgName state that can be updated with the _setOrgName() function
    const [_orgName, _setOrgName] = useState("");
    const [_orgLogoBground, _setOrgLogoBground] = useState("");
    const [_orgLogoBase64, _setOrgLogoBase64] = useState("");

    useEffect(() => { // code to run on component mount
        console.log('OrgProfile > props', props);
        /* Turns out we dont need this query, at least yet, all org elements are prvided by props.
        var dataForOrgGet = {
            id: props.currentUser.orgId
        }
        props.client.query({
            query: GET_ORG_PROFILE,
            variables: dataForOrgGet,
            optimisticResponse: null
        }).then((result:any) => {
            console.log('OrgProfile > result',  result);
            _setOrgName(result.data.syncarto_app_org[0].name);
            _setOrgLogoBase64(result.data.syncarto_app_org[0].org_logo_64);

        });
        */
       _setOrgName(props.currentUser.orgName);
       _setOrgLogoBase64(props.currentUser.orgLogo);
       _setOrgLogoBground(props.currentUser.orgLogoBground ? props.currentUser.orgLogoBground : '');
    }, []) // <-- Pass an empty array as second parameter to useEffect in order to emulate functionality of React class' componentDidMount. We only want to get the user profile once.  

    const handleSetOrgName = (e:any) => {
        _setOrgName(e);
    }
    
    const handleSetOrgLogoBground = (e:any) => {
        console.log('113023 handleSetOrgLogoBground: ', e );
        //_setOrgLogoBground(e.hex);
        _setOrgLogoBground(`rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`);
    }

    const handleSubmitOrg = (e:any) => {
        var dataForOrgSave = {
            id: props.currentUser.orgId,
            data: {
              name: _orgName,
              org_logo_64: _orgLogoBase64,
              org_logo_bground: _orgLogoBground
            }
          }
        props.client.mutate({
            mutation: UPDATE_ORG_PROFILE,
            variables: dataForOrgSave,
            optimisticResponse: null
        }).then((result:any) => {
            toastMessage("Profile updated. Please refresh to see the changes.");
            console.log("OrgProfile > result,", result);
        });
        e.preventDefault();
    }

    const toastMessage = (msg: string, type: string = 'success', options: object = {}) => {
        const { toastManager } = props;

        let toastOptions = assign({
            appearance: type,
            autoDismiss: true,
            autoDismissTimeout: 3000,
            placement: 'bottom-center'
        }, options);

        toastManager.add(msg, toastOptions);
    }
    
    // called every time a file's `status` changes
    const handleChangeStatus = ({ meta, file }:any, status:any) => { 
        console.log(status, meta, file) 
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            console.log(reader);
            //console.log(reader.result);
            var imgAsString:string = reader.result as string;
            if (imgAsString){
                _setOrgLogoBase64(imgAsString);
                //console.log('_orgLogoBase64: ', _orgLogoBase64);
            }
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
    }

    return (
        <div className="form-parent-div p-4">
            <TitleSource><h4 className="m-0 mt-1">Organization - Profile</h4></TitleSource>  
            
            <Form onSubmit={(e: any) => { handleSubmitOrg(e) }}>
                <Form.Group controlId="formOrgName">
                    <Row>
                        <Col sm="8">
                            <Form.Label>Organization Name</Form.Label>
                            <Form.Control type="text" name="orgName" placeholder="Enter organization name" value={_orgName}
                                onChange={(e: any) => handleSetOrgName(e.target.value)} />
                        </Col>
                    </Row>
                </Form.Group>

                <Form.Group controlId="formLogoBk">
                    <Row>
                        <Col sm="4">
                            <Form.Label>Logo Background Color (hex):</Form.Label>
                            <ChromePicker 
                                color={_orgLogoBground} 
                                onChangeComplete={(color: any) => handleSetOrgLogoBground(color)} 
                                onChange={(color: any) => handleSetOrgLogoBground(color)} 
                                disableAlpha={false} 
                            />
                        </Col>
                    </Row>
                </Form.Group>
            
                <Form.Group controlId="formDropZone">
                    <Form.Label>Logo</Form.Label>
                    <Dropzone
                        onChangeStatus={handleChangeStatus}
                        accept="image/*"
                        multiple={false}
                        maxFiles={1}
                        submitButtonContent={null}
                        submitButtonDisabled={true}
                        inputContent={(files:any, extra:any) => (extra.reject ? 'Image files only' : 
                            <div className="dzu-custom-input-div w-50" key="div-1" >
                                <div className="dzu-custom-input-div-child1" key="div-2" >
                                    {_orgLogoBase64 &&
                                    <img alt="Logo" key="img-1" src={_orgLogoBase64} height="50" className="dzu-custom-img"></img>
                                    }
                                </div>
                            <div className="dzu-custom-input-div-child2" key="div-3">Drag Files or Click to Upload</div>
                            </div>)}
                    />
                </Form.Group>

                <Button variant="primary" type="submit">
                    Save
                </Button>     
            </Form>
        </div>
    );
}

export default withToastManager(OrgProfile);